import { CompanyType, CompanyWrite } from "src/api/client-api/company/useCreateCompany";
import { Company } from "src/api/client-api/company/useGetOneCompany";

import { z } from "zod";

export class CompanySettingsForm {
    static getSupplierToCompanyGridForm = (existingSupplier: Company | undefined): CompanyGridForm => {
        if (!existingSupplier) return { name: "", type: "provider", email: "" };

        return {
            id: existingSupplier.id,
            name: existingSupplier.name,
            type: existingSupplier.type,
            address1: existingSupplier.address1,
            address2: existingSupplier.address2,
            city: existingSupplier.city,
            state: existingSupplier.state,
            country: existingSupplier.country,
            phone: existingSupplier.phone,
            email: existingSupplier.email ?? "",
            companySector: existingSupplier.companySector?.["@id"],
            parents: Array.isArray(existingSupplier.parents) ? existingSupplier.parents.map((p) => p["@id"]) : [],
        };
    };

    static getCompanyGridFormToCompanyWrite = (company: CompanyGridForm): CompanyWrite => {
        return {
            id: company.id,
            name: company.name ?? null,
            type: company.type,
            address1: company.address1,
            address2: company.address2,
            city: company.city,
            state: company.state,
            country: company.country,
            phone: company.phone,
            email: company.email,
            companySector: company.companySector && company.companySector !== "" ? company.companySector : null,
            parents: company.parents ?? [],
        };
    };
}

export type CompanyGridForm = {
    "@id"?: IRI;
    id?: number;
    name: string;
    type: CompanyType;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    country?: string;
    phone?: string;
    email: string;
    companySector?: string;
    parents?: string[];
};

export const CompanyGridFormZodSchema: z.ZodSchema<CompanyGridForm> = z.object({
    "@id": z.string().optional(),
    id: z.number().optional(),
    name: z.string(),
    type: z.enum(["provider", "main", "branch"]),
    address1: z.string().optional(),
    address2: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    phone: z.string().optional(),
    email: z.string().email(),
    companySector: z.string().optional(),
    parents: z.array(z.string()).optional(),
});
